import React, {Component} from "react";
import Header from "../../Layout/Header/Header";
import Footer from "../../Layout/Footer/Footer";
// import image3 from "../../../Assets/img/Image 3.png";
import facebook from "../../../Assets/img/Image 1.png";
// import google from "../../../Assets/img/google_icon.png";
import right from "../../../Assets/img/Group 2513.svg";
import notification from "../../../Assets/img/megaphone.svg";
import { authenticate, make_request, after_auth } from "../../Utils/Utils";
import Facebook from '../../Components/Facebook';
import Google from '../../Components/Google';
import ReCAPTCHA from "react-google-recaptcha";
import Topbar from "../../Layout/Header/Topbar";
import queryString from 'query-string';

const login_recaptcha_ref = React.createRef();

class Login extends Component {

  constructor(props) {
    super(props);
    this.state = {
      email: '',
      password: '',
      error_message: "",
      success_message: "",
    };
  }

  componentDidMount(){
    if(authenticate()) {
      this.props.history.push('/pre-start');
    }
    if(queryString.parse(this.props.location.search).source === "registration"){
      this.setState({success_message: "We have sent you an email to verify. Please click on the verification link in your email"})
    } else if (!!queryString.parse(this.props.location.search).account_confirmation_success) {
      this.setState({success_message: "Your email address has been successfully confirmed."})
    }
  }

  handle_change = (event) => {
    this.setState({[event.target.name]: event.target.value});
  }

  resetCaptcha = () => {
    login_recaptcha_ref.current.reset();  
  }

  submit_request = async () => {
    this.setState({success_message: "", error_message: ""});
    let edition_id = this.props.match.params.edition_id;
    const recaptcha_response = await login_recaptcha_ref.current.executeAsync();
    if(!!recaptcha_response) {
      let responseJson = await make_request({
        path: 'auth/sign_in',
        method: 'POST',
        body: {
          email: this.state.email,
          password: this.state.password,
          edition_id: edition_id,
          recaptcha_response: recaptcha_response,
        }
      });
      if(responseJson.status === "success"){
        after_auth(responseJson);
      } else {
        this.setState({error_message: responseJson.message})
      }
    }
  }

  render() {
    return (
      <div className="login innerBody">
        {
          <Topbar/>
        }
        <Header />
        <div className="container">
          <div className="row">
            <div className="col-lg-6 col-md-12 col-12">
              <div className="card mt-5 mb-5">
                <div className="bg-login"></div>
                <div className="card-body">
                  <div className="row justify-content-center pt-6">
                    <div className="col-md-9">
                      <div className="login-form">

                        <div className="d-lg-none d-md-block d-block login-right  justify-content-center">
                          <h3>Login</h3>
                          <h4>to experience the joy of Getting Puzzled!</h4>
                        </div>

                        <div className="mb-2 mt-2 text-center success_txt">
                          {
                            !!this.state.success_message &&
                            <span>{this.state.success_message}</span>
                          }
                        </div>

                        <div className="wrong_txt mb-2 mt-2 text-center">
                          {
                            !!this.state.error_message &&
                            <p>{this.state.error_message}</p>
                          }
                        </div>

                        <div className="form-group mt-3">
                          <input
                            name="email"
                            type="email"
                            className="form-control form-control-prepend"
                            id="input-email"
                            placeholder="Email Address / Phone Number *"
                            value={this.state.email}
                            onChange={this.handle_change}
                          />
                        </div>
                        <div className="form-group mb-0 mt-login">
                          <input
                            name="password"
                            type="password"
                            className="form-control form-control-prepend"
                            id="input-password"
                            placeholder="Password *"
                            value={this.state.password}
                            onChange={this.handle_change}
                          />
                        </div>
                        <div className="d-flex align-items-center justify-content-between pt-3 pb-3">
                          <div className="custom-control custom-checkbox">
                            <input
                              type="checkbox"
                              className="custom-control-input"
                              id="customCheck1"
                            />
                            <label
                              className="custom-control-label small-font pt-1"
                              htmlFor="customCheck1"
                            >
                              Keep me signed in
                            </label>
                          </div>
                          <div className="mb-2">
                            <a
                              href="/forgot-password"
                              className="text-underline--dashed border-primary mt-1 small-font"
                            >
                              Forgot Password ?
                            </a>
                          </div>
                        </div>

                        <ReCAPTCHA
                          ref={login_recaptcha_ref}
                          size="invisible"
                          sitekey={process.env.REACT_APP_GOOGLE_SITE_KEY}
                          onChange={this.resetCaptcha}
                        />
                        <div className="mt-4 text-center">
                          <button onClick={this.submit_request} className="btn btn-yellow">
                            Login
                          </button>
                        </div>
                        
                      </div>
                    </div>
                  </div>
                  <div className="row pt-4 pb-4 pl-2 pr-2 text-xs-center">
                    <div className="offset-md-1 col-md-5 col-12 mt-2 mb-2 pr-1">
                     <Google editionId={this.props.match.params.edition_id}/>
                    </div>
                    <div className="col-md-6 col-12 mt-2 mb-2 pr-1 pl-1">
                      <span className="btn-inner--icon">
                        <img src={facebook} alt="" className="fb_log_img"/> &nbsp; <Facebook editionId={this.props.match.params.edition_id}/>
                      </span>
                    </div>
                  </div>
                </div>
                <p className="text-center donthave-account">
                  Don’t have an account ? <a href="/register">Sign Up</a>
                </p>
                <div className="bg-login"></div>
              </div>
            </div>
            <div className="col-lg-6 col-md-12 col-12 login-right  justify-content-center text-center pt-5">
              <div className="d-lg-block d-md-none d-none">
              <h3>Login</h3>
              <h4>to experience the joy of Getting Puzzled!</h4>
              </div>

              <img src={right} alt="" />
            </div>
          </div>
        </div>
        <Footer />
      </div>
    );
  }
}

export default Login;
